import { horairesData } from '../../../mocks/horaires';

export default function Horaires() {
  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b51a1210d3abae23d25b3456daa64dce.jpg"
          alt="Horaires KEIKI"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black"></div>
      </div>

      <div className="relative max-w-5xl mx-auto px-6">
        <div className="bg-white/20 backdrop-blur-2xl border border-white/30 rounded-[32px] p-10 sm:p-14 shadow-2xl">
          <h2 className="text-5xl sm:text-6xl font-serif text-white text-center mb-12">
            Horaires
          </h2>

          <div className="space-y-4 mb-8">
            {horairesData.map((day, index) => (
              <div
                key={index}
                className="bg-white/15 backdrop-blur-md border border-white/25 rounded-2xl p-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3"
              >
                <span className="text-xl font-semibold text-white min-w-[120px]">
                  {day.day}
                </span>
                <div className="flex flex-col gap-1 text-right">
                  {day.hours.map((hour, idx) => (
                    <span key={idx} className="text-lg text-white/90 font-light">
                      {hour}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Happy Hour Badge */}
          <div className="flex justify-center">
            <div className="bg-emerald-600/90 backdrop-blur-md border border-emerald-500/50 rounded-full px-6 py-3 shadow-lg">
              <div className="flex items-center gap-3 text-white">
                <i className="ri-goblet-line text-2xl"></i>
                <span className="text-base sm:text-lg font-medium">
                  Happy Hour cocktails : Ven & Sam 17h–18h
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}